import Store from "../Store";
import Config from "../Config";
import {
  CONN
} from "../Enums";

export default {
  RequestIDs: [],
  Sequence: 1,
  async GetConfigs() {
    return await fetch(Config.Conf)
      .then(Res => Res.json())
      .then((Conf) => {
        return Conf;
      });
  },
  IsNumeric(Arg) {
    return !isNaN(parseFloat(Arg)) && isFinite(Arg);
  },
  Delay(Callback, MS) {
    const Interval = setInterval(() => {
      Callback();
      clearInterval(Interval);
    }, MS);
  },
  async Connection() {
    window.WebSocket = window.WebSocket || window.MozWebSocket;

    if (!window.WebSocket) {
      window.alert("Kullandığınız internet tarayıcısı WEBSOCKET teknolojisini desteklemiyor!");
      return false;
    }

    const Conf = await Store.dispatch("GetConf");

    var WS = new WebSocket(`ws://${Conf.Server}:${Config.WS.Port}/`);

    return WS;
  },
  Send(OpCode, Data, Callback) {
    if (Store.state.ConnectionStatus !== CONN.CONNECTED)
      return false;

    if (typeof Data !== 'object')
      return false;

    var Request = {
      OpCode,
      Data,
      AccessToken: Store.state.AccessToken,
    };

    if (Callback != undefined && Callback != null) {
      Request.ID = this.Sequence;

      this.RequestIDs[this.Sequence] = Callback;

      if (this.Sequence < Number.MAX_SAFE_INTEGER) this.Sequence++;
      else this.Sequence = 1;
    }

    return Store.state.Connection.send(JSON.stringify(Request));
  },
  Console(Message) {
    this.Send('Console', {
      Message,
    });
  },
  Login(Username, Password, Callback) {
    this.Send('Login', {
      Username,
      Password,
    }, Callback);
  },
  Logout() {
    this.Send('Logout', {});
  },
  Order(Table, Orders, Callback) {
    this.Send('Orders', {
      Table,
      Orders,
    }, Callback);
  },
  Subscribe(Type, Channel) {
    this.Send('Subscribe', {
      Type,
      Channel,
    });
  },
  UnSubscribe(Channel) {
    this.Send('UnSubscribe', {
      Channel,
    });
  },
  UnSubAll(Type) {
    this.Send('UnSubAll', {
      Type,
    });
  },
  Up(Root, Data) {
    let Schema = Root;

    const El = Data.El;
    const Len = El.length;

    for (var i = 0; i < Len - 1; i++) {
      const _El = El[i];

      if (!Schema[_El]) Schema[_El] = {}
      Schema = Schema[_El];
    }

    Schema[El[Len - 1]] = Data.Value;
  },
  Del(Root, Data) {
    let Schema = Root;

    const El = Data.El;
    const Len = El.length;

    for (var i = 0; i < Len - 1; i++) {
      const _El = El[i];

      if (!Schema[_El]) Schema[_El] = {}
      Schema = Schema[_El];
    }

    delete Schema[El[Len - 1]];
  }
};